module.exports = __webpack_public_path__ + "img/QuentinBacchus_LEMON_HEARC_Oct2020-5-1024x683.3a8657f5.jpg";